export default __webpack_public_path__ + "static/media/LC.accf9b3a.svg";